import { getAllSpecializationAreasReq } from "../../../../../redux/guest-slices/common.slice"
import SpecializationAreas from "../../../../../components/ui/SpecializationAreas"
import InputField1 from "../../../../../components/ui/InputField1"
import { validateNumber } from "../../../../../utils/velidations"
import FileInput from "../../../../../components/ui/FileInput"
import { Grid2 as Grid, Typography } from "@mui/material"
import { useDispatch, useSelector } from "react-redux"
import { Fragment, useEffect, useState } from "react"

function CareerCoach({ errors, files, onChangFun }) {
  const dispatch = useDispatch()
  const [areas, setAreas] = useState([])
  const { specialist } = useSelector(state => state.specialistSlice)

  const handleGetAreas = (filters) => {
    dispatch(getAllSpecializationAreasReq({
      limit: filters?.limit || 10,
      id: "67d90056c2c4d5ab747f8b32"
    })
    ).unwrap().then((data) => {
      setAreas(data)
    }).catch(() => { })
  }

  useEffect(() => {
    handleGetAreas()

    // eslint-disable-next-line
  }, [])

  return (
    <Fragment>
      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="specializationCertificate"
          errText="Please upload upload professional qualifications"
          label="Professional Qualifications (Degrees, Certifications) *"
          defaultValue={specialist?.profile?.specializationCertificate || []}
          placeholderText="Upload Professional Qualifications (Degrees, Certifications)"
        />
      </Grid>

      <Grid size={12}>
        <SpecializationAreas
          areas={areas}
          errors={errors}
          onChangFun={onChangFun}
          label="Specialization Areas *"
        />
      </Grid>

      <Grid size={12}>
        <InputField1
          type="text"
          errors={errors}
          name="experience"
          onChangeFun={validateNumber}
          label="Experience in Relevant Expertise *"
          placeholder="Enter Years of Experience *"
          errText="Please enter years of experience"
          defaultValue={specialist?.profile?.experience || ""}
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="clientDemographics"
          errText="Please upload clientele demographics"
          defaultValue={specialist?.profile?.coachingCertifications || []}
          label="Clientele Demographics (e.g., Professionals, Students) *"
          placeholderText="Upload Clientele Demographics (e.g., Professionals, Students)"
        />
      </Grid>

      <Grid size={12} sx={{ "> div + div:has(div)": { mt: 2 } }}>
        <FileInput
          files={files}
          errors={errors}
          name="additionalCertificates"
          label="Section for Credentials"
          placeholderText="Upload Additional Certificates"
          defaultValue={specialist?.profile?.additionalCertificates || []}
        />
      </Grid>

      <Typography
        color="#7A8A9E"
        fontWeight="500"
        fontStyle="italic"
      >Welcome to InnerPal's Career Coach Registration. We're excited to have you share your expertise in career development and mentoring. Please fill in your details to help us connect you with those seeking your guidance
      </Typography>
    </Fragment>
  )
}

export default CareerCoach